import React from 'react';

import { Container } from './styles';

function BoxFile({onClick, noMargin, isLink, children, noAction}) {
  return (
    <Container onClick={onClick} noMargin={noMargin} isLink={isLink} noAction={noAction}>
      {children}
    </Container>
  );
}

export default BoxFile;
